import React from "react";
import {Box} from "@mui/material";
import AuthProvider from "../../hooks/authProvider";
import {redirect} from "react-router-dom";
import PageTitle from "../../components/PageTitle";

export async function loader({request, params}) {
    if (!(await AuthProvider.checkAuth())) {
        const params = new URLSearchParams();
        params.set("from", new URL(request.url).pathname);
        return redirect("/login?" + params.toString());
    }
    return null;
}

export default function DocsViewer() {
    return (
        <Box
            sx={{
                width: "100vw", // На всю ширину экрана
                height: "calc(100vh - 64px)", // Минус высота возможного AppBar
                overflow: "hidden" // Скрываем лишние полосы прокрутки
            }}
        >
            <PageTitle title="Документація (бекенд)" />
            <iframe
                src="/pPvTTf1vCQ19lk4ARyQd/index.html"
                title="Docs"
                style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    transform: "scale(1.1)", // Увеличивает масштаб
                    transformOrigin: "top left"
                }}
            />
        </Box>
    );
}
